import React, { JSX, useState } from 'react';
import Icons from 'components/atoms/Icons';

type SearchProps = {
  onSearch: (searchText: string) => void;
  value: string;
};

const Search = (props: SearchProps): JSX.Element => {
  const { onSearch, value } = props;
  const [searchText, setSearchText] = useState('');

  React.useEffect(() => {
    setSearchText(value);
  }, [value]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchText);
  };

  return (
    <div className="search-wrapper">
      <div className="search-bar overhauled">
        <form onSubmit={handleSubmit}>
          <div className="search-input">
            <div className="input-wrapper">
              <Icons id="search" className="search-icon" />
              <input
                type="text"
                placeholder="Keywords"
                value={searchText ?? ''}
                onChange={e => setSearchText(e.target.value)}
              />
            </div>
            <button type="submit" className="btn-primary">
              Search
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Search;
